import React, { Component } from 'react';
import { AppBar, Card, Divider, Typography, Icon, IconButton } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles/index';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as instructorActions from '../../instructor/store/actions';

const styles = theme => ({
    root: {}
});

class InstructorToDoList extends Component {

    constructor(props) {
        super(props);
        this.props.getDayEvents(this.props.auth.user.data.role_info.link_id, moment(new Date()).format('YYYY-MM-DD'))
    }

    render() {
        const { classes, dayEvents } = this.props;

        const todoData = dayEvents.filter(e => e.Unscheduled === 1).map(event => {
            const eventHeader = event.eventType === 'dayEventAssignment' ? 'Assignment' : 'Quiz'
            return (
                <tr key={event.id}>
                    <td>{event.title}</td>
                    <td>{eventHeader}</td>
                    <td>
                        <IconButton
                            style={{ padding: '0px', margin: '0px' }}
                            onClick={() => this.props.history.push(`/grade/student/list/` + event.id)}
                        >
                            <Icon>search</Icon>
                        </IconButton>
                    </td>
                </tr>
            )
        });

        if (todoData.length === 0) {
            return (
                <div>
                    <AppBar position="static">

                        <div className="p-16 pr-4 flex flex-row items-center justify-between">
                            <Typography className="h1 pr-16" color="inherit">ToDo {moment(new Date).format('MMM Do, YYYY')}</Typography>
                        </div>
                    </AppBar>
                    <Typography className="text-center p-8" color="inherit">No ToDos!</Typography>
                </div>



            )

        }

        return (
            <Card className={classNames(classes.root, "w-full")}>
                <AppBar position="static">

                    <div className="p-16 pr-4 flex flex-row items-center justify-between">
                        <Typography className="h1 pr-16" color="inherit">ToDo {moment(new Date).format('MMM Do, YYYY')}</Typography>
                    </div>
                </AppBar>
                <table className="simple">
                    <thead>
                        <tr>
                            <th>Event</th>
                            <th>Event Type</th>
                            <th>Gradebook</th>
                        </tr>
                    </thead>
                    <tbody>
                        {todoData}
                    </tbody>
                </table>

                <Divider className="card-divider w-full" />
            </Card>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getDayEvents: instructorActions.getDayEvents
    }, dispatch);
}

function mapStateToProps({ auth, instructorApp }) {
    return {
        auth: auth,
        dayEvents: instructorApp.instructors.dayEvents
    }
}


export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(InstructorToDoList)));



// WEBPACK FOOTER //
// src/main/content/dashboard/widgets/InstructorToDoList.js